import React, { useState, useEffect } from 'react';

import DataTable from 'common-components/DataTable';
import { columns } from './statusTableColumns';

import './statusTable.style.css';


const StatusTable = ({ tableRowData }) => {

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (tableRowData) {
      setIsLoading(false);
    }
  }, [tableRowData])

  return (
    <>
      <div className='status-table-container'>
        <DataTable
          title='PUBLISHED STATUS FROM URI DATABASE'
          wrapperClassName='status-table'
          rows={tableRowData ? tableRowData : []}
          columns={columns}
          pageSizeOptions={[20, 50, 100]}
          searchableFields={['url', 'message']}
          isLoading={isLoading}
        />
        <div className='status-table-message'>
          Table shows response from URI database for the last publish. Table data is discarded on page refresh.
        </div>
      </div>
    </>
  )
};

export default StatusTable;
